import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxDataGridModule,
    DxFormComponent,
    DxFormModule,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { AccessType, AuthService, PermissionType, ServiceTypeGridViewDto } from '@services';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import { FilterConfig, GridPageComponent} from '../../common/grid-page.component';

@Component({
    selector: 'app-service-types',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxoScrollingComponent,
        DxButtonComponent,
        DxiItemComponent,
        DxDataGridModule,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxFormComponent,
        FilterPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxFormModule,
    ],
    templateUrl: './service-types.component.html',
})
export class ServiceTypesComponent extends GridPageComponent<ServiceTypeGridViewDto> {
    @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;
    private authService = inject(AuthService);

    protected override exportName: string = 'Service Types Report';
    protected offset: number = 100;

    dataSource = this.dataSources.serviceTypes();

    protected override filterConfig: FilterConfig[] = [
        { field: 'Name', op: 'contains' },
    ];

    constructor() {
        super();
        this.init(ServiceTypeGridViewDto);
    }

    addNew() {
        this.grid.instance.addRow();
    }

    onRowUpdating(e: any) {
        e.newData = Object.assign({}, e.oldData, e.newData);
    }

    onRowDblClick(e: any) {
        if (e.rowType === "data" && this.canManage) {
            e.component.editRow(e.rowIndex);
        }
    }

    get canManage() {
        return this.authService.checkPermission(PermissionType.ServiceTypes, AccessType.Manage);
    }
}
